import { Service, ApiResponse } from '@roc/feature-app-core';

export abstract class DocReviewBaseService extends Service {
  abstract getDocReviewData(id: number, type: string, disableGlobalLoading?: boolean): Promise<ApiResponse>;
  abstract getDocChecklist(id: number, type: string): Promise<ApiResponse>;
  abstract saveDocChecklist(list: any[]): Promise<ApiResponse>;
  abstract saveDocReviewData(id: number, type: string, data: any): Promise<ApiResponse>;
  abstract sendRevisionDoc(id: number, type: string): Promise<ApiResponse>;
  abstract changeStatus(loanId: number, type: string, status: string, data: string): Promise<ApiResponse>;
  abstract getAutomationStatus(loanId: number, type: string): Promise<ApiResponse>;
  abstract getRevisionComment(docType: string, key: string): Promise<ApiResponse>;
}
